import React from 'react'
import { HighlightCard } from 'ui/cards'
import WhenOrderIsDraft from 'pages/app/inventory/order/partials/WhenOrderIsDraft'
import WhenCanAdjustInventoryOrder from 'pages/app/inventory/order/partials/WhenCanAdjustInventoryOrder'
import { useEnvValue } from '@morningtrain/react-helpers'
import { Translation } from '@morningtrain/react-translations'
import * as UI from 'ui'

function InventoryOrderExpectedGuestsHighlightCard (props) {
  const [weekdays] = useEnvValue('globals.inventory.delivery_days.weekdays', [])
  const [dates] = useEnvValue('globals.inventory.delivery_days.dates', {})
  const [guestCounts] = useEnvValue('globals.inventory.delivery_days.guest_counts', {})

  function sumGuestCounts () {
    let count = 0

    if (weekdays.length > 0) {
      weekdays.forEach(weekday => {
        if (dates[weekday]) {
          const date = dates[weekday]
          if (guestCounts[date]) {
            count += guestCounts[date]
          }
        }
      })
    }

    return count
  }

  const [summedGuestCounts, setSummedGuestCounts] = React.useState(sumGuestCounts())

  React.useEffect(() => {
    setSummedGuestCounts(sumGuestCounts())
  }, [weekdays, dates, guestCounts])

  return (
    <WhenCanAdjustInventoryOrder>
      <WhenOrderIsDraft>
        <HighlightCard
          title={<Translation name='inventory.fragments.guests_count_title' data={{ amount: summedGuestCounts }} />}
          content={<Translation name='inventory.fragments.guests_count_content' data={{ amount: summedGuestCounts }} />}
          box={<UI.Icons.Users />}
        />
      </WhenOrderIsDraft>
    </WhenCanAdjustInventoryOrder>
  )
}

export default InventoryOrderExpectedGuestsHighlightCard
